import React from 'react'

export default function SmartPhone() {
    return (
        <div>
           <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_357_2340)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M131.25 40.8333C136.08 40.8333 140 44.7533 140 49.5833V131.25C140 136.068 136.086 140 131.25 140H90.4167C85.5808 140 81.6667 136.062 81.6667 131.25V49.5833C81.6667 44.7592 85.5925 40.8333 90.4167 40.8333H131.25ZM79.2925 140H23.3333L38.4942 122.5H75.8333V133.023C75.8333 136.401 77.7933 139.382 79.2925 140ZM110.833 134.167C107.608 134.167 105 131.553 105 128.333C105 125.113 107.608 122.5 110.833 122.5C114.053 122.5 116.661 125.113 116.661 128.333C116.661 131.553 114.053 134.167 110.833 134.167ZM134.167 116.667V58.1933H87.5V116.667H134.167ZM128.333 35H116.667V11.6667H11.6667V99.1667H75.8333V110.833H0V0H128.333V35ZM113.75 52.5C115.354 52.5 116.667 51.1933 116.667 49.5833C116.667 47.9733 115.354 46.6667 113.75 46.6667H107.917C106.307 46.6667 105 47.9733 105 49.5833C105 51.1933 106.307 52.5 107.917 52.5H113.75Z" fill="black" />
                </g>
                <defs>
                    <clipPath id="clip0_357_2340">
                        <rect width="140" height="140" fill="white" />
                    </clipPath>
                </defs>
            </svg>
            

        </div>
    )
}
